import React, {PropsWithChildren} from 'react'
import {Button, ButtonPriority, HoverStyles, PaddingModes} from 'wix-ui-tpa/cssVars'

import {ButtonAlignment} from '../../../../components-shared/Alignment'
import {Alignment as AlignmentEnum} from '../../../../types/createStylesParams'

import {classes, st} from './ReserveButton.st.css'
import {reserveButtonDataHooks} from './constants'

interface Props {
  onClick?: () => void
  width?: number
}

export const ReserveButton = ({onClick, children, width}: PropsWithChildren<Props>) => {
  return (
    <ButtonAlignment alignment={AlignmentEnum.Left} className={st(classes.container)}>
      <Button
        className={st(classes.root)}
        priority={ButtonPriority.primary}
        hoverStyle={HoverStyles.underline}
        paddingMode={PaddingModes.explicitPaddings}
        onClick={onClick}
        type="submit"
        style={{
          ...(width ? {width: `${width}px`} : {}),
        }}
        data-hook={reserveButtonDataHooks.button()}
      >
        {children}
      </Button>
    </ButtonAlignment>
  )
}
